// Hides on scroll-down, slides back in on scroll-up (owner brief, 2026-10-30) —
// not pinned permanently, and not gone until the shopper scrolls all the way back
// to the top. Always shown near the top of the page so the hide doesn't trigger on
// the first small scroll.
class StickyHeader extends HTMLElement {
  connectedCallback() {
    this.lastScrollY = window.scrollY;
    this.ticking = false;
    window.addEventListener('scroll', () => this.requestTick(), { passive: true });
  }

  requestTick() {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(() => {
      this.handleScroll();
      this.ticking = false;
    });
  }

  handleScroll() {
    const currentScrollY = window.scrollY;
    const delta = currentScrollY - this.lastScrollY;
    const revealThreshold = this.offsetHeight || 0;

    if (currentScrollY <= revealThreshold) {
      this.classList.remove('-translate-y-full');
    } else if (delta > 0) {
      this.classList.add('-translate-y-full');
    } else if (delta < 0) {
      this.classList.remove('-translate-y-full');
    }

    this.lastScrollY = currentScrollY;
  }
}

customElements.define('sticky-header', StickyHeader);
